function loadShopifyXR() {
  console.log("Loading ShopifyXR features");
  Shopify.loadFeatures(
    [
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: setupShopifyXR,
      },
    ],
    function (loadError) {
      if (loadError) {
        console.error("Error loading ShopifyXR features:", loadError);
      }
    }
  );
}

function setupShopifyXR(errors) {
  console.log("setupShopifyXR called with errors:", errors);
  if (errors) {
    console.error("Errors loading Shopify XR:", errors);
    return;
  }

  if (!window.ShopifyXR) {
    console.log("ShopifyXR not available, adding event listener");
    document.addEventListener("shopify_xr_initialized", () => {
      console.log("shopify_xr_initialized event triggered");
      setupShopifyXR();
    });
    return;
  }

  const modelJSONElements = document.querySelectorAll('[id^="Product3DJSON-"]');
  console.log(`Found ${modelJSONElements.length} ProductJSON elements`);

  modelJSONElements.forEach((modelJSON, index) => {
    try {
      const modelData = JSON.parse(modelJSON.textContent);
      console.log(`Adding model ${index + 1}:`, modelData);
      window.ShopifyXR.addModels(modelData);
      modelJSON.remove();
    } catch (e) {
      console.error("Error parsing JSON for model:", e);
    }
  });

  if (window.ShopifyXR.setupXRElements) {
    console.log("Setting up XR elements");
    window.ShopifyXR.setupXRElements();
  } else {
    console.error("ShopifyXR.setupXRElements is not a function");
  }
}

window.addEventListener("DOMContentLoaded", () => {
  console.log("DOM fully loaded and parsed");
  loadShopifyXR();
});
